import React from 'react';

import {
  HStack, Link, Stack, Text,
} from '@chakra-ui/react';
import dayjs from 'dayjs';

import { Icon } from 'components';
import { ShippingTypes } from 'enums/types';

interface DispatchCardProps{
    id: string | number
    code?: string
    operator : string
    dispatchSource:{
        name:string
        address: {
            city: string
        }
    }
    dispatchDestination:{
        name:string
        address: {
            city: string
        }
    }
    collectAt: Date
    boardingAt: Date
    shipping: ShippingTypes
    routeId: string | number
}

export default function DispatchCard({ ...rest }:DispatchCardProps) {
  return (
    <HStack
      p={6}
      borderRadius={8}
      width="100%"
      bg="white.default"
      justifyContent="space-between">
      <HStack
        width="15%"
        spacing={8}>
        <Icon name="plane" />
        <Stack>
          <Text
            color="gray.600"
            variant="mediumBold">
            {rest.code}
          </Text>
          <Text
            color="gray.500"
            variant="xSmallSemiBold">
            {rest.operator}
          </Text>
        </Stack>
      </HStack>
      <HStack
        spacing={4}
        width="40%">
        <Stack>
          <Text
            color="gray.600"
            variant="xSmallBold">
            {rest.dispatchSource?.name}
          </Text>
          <Text
            color="gray.400"
            varaint="xSmallSemiBold">
            {rest.dispatchSource?.address?.city}
          </Text>
        </Stack>
        <Icon name="arrows-alt-h" />
        <Stack>
          <Text
            color="gray.600"
            variant="xSmallBold">
            {rest.dispatchDestination?.name}
          </Text>
          <Text
            color="gray.400"
            varaint="xSmallSemiBold">
            {rest.dispatchDestination?.address?.city}
          </Text>
        </Stack>
      </HStack>
      <Stack>
        <Text
          color="gray.500"
          variant="xSmallSemiBold">
          Embarque:
          <Text
            as="span"
            variant="xSmallRegular">
            {dayjs(rest.boardingAt).format('HH:mm')}
          </Text>
        </Text>
        <Text
          color="gray.500"
          variant="xSmallSemiBold">
          Retirada:{' '}
          <Text
            as="span"
            variant="xSmallRegular">
            {dayjs(rest.collectAt).format('HH:mm')}
          </Text>
        </Text>
      </Stack>
      <Stack>
        <Text
          color="gray.500"
          variant="xSmallSemiBold">ID:{' '}
          <Text
            as="span"
            color="gray.500"
            variant="xSmallBold">
            {rest.id}
          </Text>
        </Text>
        <Link href={`/routes/${rest.routeId}`}>
          <Text
            color="primary.default"
            variant="xSmallSemiBold">Ver na Rota
          </Text>
        </Link>
      </Stack>
    </HStack>
  );
}
